export const LocalStorageMissionsKeys = {
  MISSIONS: 'cache:betting:missions:missions',
  ACHIEVEMENTS: 'cache:betting:missions:achievements',
  USER_MISSIONS: 'cache:betting:missions:user_missions',
  USER: 'cache:betting:missions:user',
  SEEN_MISSIONS: 'application:betting:seen-missions',
};
